import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/app/api/api';
import { ApiSearch } from 'src/app/api/services/api-utils.service';
import { Presentation } from 'src/app/api/services/presentation';
import { PresentationApiService } from 'src/app/api/services/presentation-api.service';
import { User } from 'src/app/api/services/user';
import { UserApiService } from 'src/app/api/services/user-api.service';
import { ModalService } from 'src/app/components/modals/modal.service';
import { RequestChangesDialogComponent } from 'src/app/editor/components/request-changes-dialog/request-changes-dialog.component';
import { ReviewRequestComponent } from 'src/app/editor/components/review-request/review-request.component';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  constructor(
    private presentationApiService: PresentationApiService,
    private modalService: ModalService,
    private userApiService: UserApiService,
  ) {}

  requestPublish(presentationId: string): Promise<ApiResponse<Presentation>> {
    return this.modalService
      .showMediumDialog(ReviewRequestComponent, null, { maxHeight: '85vh' })
      .then((result: { reviewerIds: string[]; notes: string }) => {
        if (result?.reviewerIds?.length) {
          const { reviewerIds, notes } = result;
          return this.requestPublishForReviewer(
            presentationId,
            reviewerIds,
            notes,
          );
        }
        return Promise.resolve(null);
      });
  }

  requestChanges(presentation: Presentation) {
    return this.modalService
      .showMediumDialog(RequestChangesDialogComponent, {
        reviewRequestedBy: presentation.reviewRequestedBy,
      })
      .then((result) => {
        if (result) {
          return this.requestChangesForReviewer(presentation.id, result.notes);
        }
      });
  }

  listReviewers(
    search: ApiSearch & { companyId: string },
  ): Promise<ApiResponse<User>> {
    return this.userApiService.getReviewers(search.companyId);
  }

  private requestPublishForReviewer(
    presentationId: string,
    reviewerIds: string[],
    notes: string,
  ): Promise<ApiResponse<Presentation>> {
    return this.presentationApiService.requestPublish(
      presentationId,
      reviewerIds,
      notes,
    );
  }

  private requestChangesForReviewer(presentationId: string, notes: string) {
    return this.presentationApiService.requestChanges(presentationId, notes);
  }
}
